import React from 'react';
import ReportUsageHeader from './ReportUsageHeader';

const Header = ({
    isPriceOverride,
    backIconClickHandler,
    shipAddress,
    setshowReportPayment,
    showReportPayment,
    isNavigatedToReportPayment,
    selectedPhysicianData,
    setViewSurgeryNotes,
    viewSurgeryNotes,
    noteCount
}) => {
    return (
        <>
            <ReportUsageHeader
                backIconClickHandler={backIconClickHandler}
                isPriceOverride={isPriceOverride}
                setshowReportPayment={setshowReportPayment}
                showReportPayment={showReportPayment}
                isNavigatedToReportPayment={isNavigatedToReportPayment}
                shipAddress={shipAddress}
                selectedPhysicianData={selectedPhysicianData}
                setViewSurgeryNotes={setViewSurgeryNotes}
                viewSurgeryNotes={viewSurgeryNotes}
                noteCount = {noteCount}
            />
        </>
    );
};

export default Header;
